<script setup>
import { onMounted } from "vue";
import { useRouter,useRoute } from "vue-router";
import API from "@/axios";
const router = useRouter();
const route = useRoute();

onMounted(() => {
  API({
    url: "/web/wapWxLogin",
    method: "post",
    data:{
      'loginKey':route.query.loginkey //线上
    }
  }).then((res) => {
    if(res.data.status == 200){
      router.push({
        path: "/enter/h5Home",
      });
    }
  });
});

</script>

